import React from 'react';

import LogoHoldemFlash from '../assets/logo-spingo-flash.svg';
import LogoHoldem from '../assets/logo-spingo-holdem.svg';
import LogoHoldemMax from '../assets/logo-spingo-max.svg';
import LogoOmaha from '../assets/logo-spingo-omaha.svg';
import styles from '../styles/shared.scss';

import {
  TXTCLI_A_Spin_X_Go_is_a_fast_pacedX_3_ELL,
  TXTCLI_Flash_offers_a_faster_paced_ve_ELL,
  TXTCLI_Spin_X_Go_Max_is_a_fast_pacedX_ELL,
  TXTCLI_Spin_X_Go_Omaha_is_a_fast_pace_ELL
} from './gameData.messages.json';

export default {
  Holdem: {
    translation: TXTCLI_A_Spin_X_Go_is_a_fast_pacedX_3_ELL,
    icon: <LogoHoldem className={styles.logo} />
  },
  HoldemFlash: {
    translation: TXTCLI_Flash_offers_a_faster_paced_ve_ELL,
    icon: <LogoHoldemFlash className={styles.logo} />
  },
  HoldemMax: {
    translation: TXTCLI_Spin_X_Go_Max_is_a_fast_pacedX_ELL,
    icon: <LogoHoldemMax className={styles.logo} />
  },
  Omaha: {
    translation: TXTCLI_Spin_X_Go_Omaha_is_a_fast_pace_ELL,
    icon: <LogoOmaha className={styles.logo} />
  }
};
